import {createAction} from '@reduxjs/toolkit'

import {isEmpty} from '@shared/helpers/lang'

import getApi, {createApiAsyncThunk, createWrapper, getCommonBaseUrl} from '@web/helpers/api'
import {isPC} from '@web/helpers/userAgent'

import {AdStatusType, AiTEMSState} from '../interfaces'
import {nvMidsSelector} from '../selectors'

import {FetchAiTEMSResponse} from './apis/interfaces'

const api = getApi(getCommonBaseUrl())

type RootState = {
    aitems: AiTEMSState
}

/** AiTEMS 정보 조회 */
export const getAiTEMS = createApiAsyncThunk<FetchAiTEMSResponse, void, {state: RootState}>(
    'aitems/getInfo',
    async (_, {rejectWithValue, getState}) => {
        const state = getState()
        const nsc = isPC ? 'pay.etcs' : 'Mpay.etcs'
        const nvMids = nvMidsSelector(state)

        if (!nvMids) {
            return rejectWithValue('PROPS_NOT_VALIDATE')
        }

        const result = await createWrapper<FetchAiTEMSResponse>(
            api.get('aitems/v1', {
                params: {
                    nsc,
                    nvMids,
                },
            }),
        )

        if (isEmpty(result.tabs)) {
            return rejectWithValue('RESPONSE_NOT_VALIDATE')
        }

        return result
    },
)

/** aitems page 변경 */
export const updateAiTEMSPage = createAction<number>('aitems/updatePage')

export const updateAdStatus = createAction<AdStatusType>('aitems/updateAdStatus')
